import React from 'react'

import ShareTab from '../../../share-tab'

const PlaylistShareTab = props => {
  return <ShareTab shareType={'playlist'} {...props} />
}

export default PlaylistShareTab
